import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Cliente } from 'src/app/interfaces/cliente';
import { ClienteService } from 'src/app/service/cliente.service';

@Component({
  selector: 'app-logon',
  templateUrl: './logon.component.html',
  styleUrls: ['./logon.component.css']
})
export class LogonComponent implements OnInit {
  public cargado:boolean=false;
  public cliente: Cliente;
  constructor(private dialogRef: MatDialogRef<LogonComponent>, private clienteService: ClienteService) {
    this.cliente={
      id: 0,
      email: '',
      password: '',
      token: '',
      estado: 0,
      dni: 0,
      nombres: ''}
   }

  ngOnInit(): void {
  }
  cargar(){
    this.clienteService.postCliente(this.cliente).then((data:any)=>{
      if(data>0){
        this.cargado=true;
      }


    });
  }

}
